import { disableScroll } from '../functions/disable-scroll';
import { enableScroll } from '../functions/enable-scroll';
import { CarCard } from './carCard';
import vars from '../_vars';

vars.carCards = getCarCards()

export function getCarCards() {
  const cardNodes = document.querySelectorAll('[data-id-car]')
  return [...cardNodes].map(cardNode => new CarCard(cardNode))
}

// let carCards = getCarCards()

export default function modalRental() {
  let modalRental = document.querySelector('[data-modal="rental"]')
  if (!modalRental) return;

  // const cardNodes = document.querySelectorAll('[data-id-car]')
  // if (cardNodes.length === 0) return;
  if (vars.carCards.length === 0) return;

  // console.log(cardNodes)
  // window.cardNodes = cardNodes

  let carIndex = 0
  let inputTimeoutId
  const rentalDaysInput = modalRental.querySelector('#rentalDays')
  // const carCards = [...cardNodes].map(cardNode => new CarCard(cardNode))
  // const carRentButtons = document.querySelectorAll('.js-order-car')
  const wrapper = document.querySelector('.modal-wrapper')
  // const modalRentalClose = modalRental.querySelector('.js-modal-close')

  // console.log(carCards)
  document.removeEventListener('click', checkClickOnButton)
  rentalDaysInput.removeEventListener('input', onInputRentalDaysInput)

  document.addEventListener('keydown', (event) => {
    if (event.code === "Escape") closeModal()
  })

  // wrapper?.addEventListener('click', (e) => {
  //   if (!e.target.closest('.modal')) closeModal()
  // })

  // modalRentalClose.addEventListener('click', closeModal)

  document.addEventListener('click', checkClickOnButton)

  function checkClickOnButton(event) {
    if (event.target.closest('.js-order-car')) {
      const carRentButton = event.target.closest('.js-order-car')
      onModalButtonClick(event)
    }
  }

  function onModalButtonClick(event) {
    const target = event.target
    const carId = target?.closest('[data-id-car]')?.dataset?.idCar
    if (!carId) return
    carIndex = carId
    setModalData()
    openModal('rental')
  }

  rentalDaysInput.addEventListener('input', onInputRentalDaysInput)

  function onInputRentalDaysInput(event) {
    clearTimeout(inputTimeoutId)
    
    inputTimeoutId = setTimeout(() => {
      if (!event.target.value || event.target.value == 0) event.target.value = 1
    }, 800);
    setModalData()
  }

  function setModalData() {
    const car = vars.carCards.find(carCard => carCard.el.dataset.idCar === carIndex)
    const name = modalRental.querySelector('#modalCarName'),
                 priceTotal = modalRental.querySelector('#modalTotalPrice'),
                 priceTotalUSD = modalRental.querySelector('#modalTotalPriceUSD'),
                 priceDay = modalRental.querySelector('#modalPriceDay'),
                 priceDayUSD = modalRental.querySelector('#modalPriceDayUSD'),
                 deposit = modalRental.querySelector('#modalDeposit'),
                 depositUSD = modalRental.querySelector('#modalDepositUSD'),
                 priceInput = modalRental.querySelector('input[name="price"]'),
                 carSelectInput = modalRental.querySelector('input[name="carSelect"]');

    const pricePerDay = car.getPricePerDay(rentalDaysInput.value)
    const totalPrice = car.getTotalPrice(rentalDaysInput.value)

    name.innerText = car.name
    carSelectInput.value = car.name
    priceTotal.innerText = totalPrice.AED
    priceInput.value = totalPrice.AED
    priceTotalUSD.innerText = totalPrice.USD
    deposit.innerText = car.deposit.AED
    depositUSD.innerText = car.deposit.USD
    priceDay.innerText = pricePerDay.AED
    priceDayUSD.innerText = pricePerDay.USD
  }

  function openModal(modalType) {
    let modals = document.querySelectorAll('.modal')
    modals.forEach(modal => {
      modal.classList.remove('modal--active')
    })

    wrapper?.classList.add('modal-wrapper--active');
    modalRental.classList.add('modal--active')
    if (!document.body.classList.contains('dis-scroll')) {
      disableScroll();
    }
  }

  function closeModal() {
    wrapper?.classList.remove('modal-wrapper--active');
    enableScroll();
  }
}